import React, { useState } from 'react';
import ExpenseItem from "./ExpenseItem";
import ExpensesFilter from '../ExpensesFilter/ExpensesFilter';
import Card from '../UI/Card';
import './ExpenseItem.css';
import ExpensesChart from './ExpensesChart';
export default function Expenses(props) {

  const [filteredValue, setfilteredValue] = useState('0000');

  const addFilterChange = (filters) =>{
    // console.log('In expenses.js');
    // console.log(filters);
    setfilteredValue(filters)
  }

  const filteredExpenses = props.expenses.filter(expense=>{
    return expense.date.getFullYear().toString()===filteredValue;
  });

  return (
    <Card className="expenses">
      <ExpensesFilter selected = {filteredValue} onFilterChange = {addFilterChange}/>
      <ExpensesChart expenses = {filteredExpenses}/>
      {filteredValue === '0000' ? (
        props.expenses.map((expense) =>(
          <ExpenseItem 
          title={expense.title}
          amount = {expense.amount}
          date= {expense.date} />
          ))
      ) : (
        filteredExpenses.length === 0 ? (<p>No Expenses Found</p>) : (

          filteredExpenses.map((expense) =>(
            <ExpenseItem 
            title={expense.title}
            amount = {expense.amount}
            date= {expense.date} />
            ))

        )
      )}



      {/* {filteredExpenses.length === 0 ? (<p>No Expenses Found</p>) : (

        filteredExpenses.map((expense) =>(
          <ExpenseItem 
          title={expense.title}
          amount = {expense.amount}
          date= {expense.date} />
          ))

      )} */}
      </Card>
  )
}
